export default {
  pending: 'Pendente',
  accepted: 'Aprovada',
  rejected: 'Rejeitada',
  delayed: 'Atrasada',
  canceled: 'Cancelada'
};
